export default __webpack_public_path__ + "static/media/34_TopRightSquares_RotateRight.e45d547d.mp4";